import { getCompany } from '@dispatch/shared/services';
import { useQuery } from 'react-query';

export const useGetCompany = (enabled = true) => {
  const { data, status, refetch } = useQuery(['company'], () => getCompany(), {
    staleTime: 60000,
    enabled,
  });

  return {
    companyData: data,
    companyStatus: status,
    companyRefetch: refetch,
  };
};
